var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.978 0c.128 0 .255.029.374.086a.98.98 0 01.317.243l12.045 13.875c.183.211.286.497.286.796 0 .298-.103.585-.286.796L1.669 29.67a.98.98 0 01-.317.244.866.866 0 01-.748 0 .98.98 0 01-.317-.244 1.15 1.15 0 01-.212-.365 1.276 1.276 0 010-.861c.049-.137.12-.26.211-.365L11.641 15 .286 1.922a1.187 1.187 0 01-.267-.577 1.285 1.285 0 01.055-.65C.148.489.274.313.434.19.596.066.785 0 .979 0z",
    fill: "#D8D8D8"
  })));
}

export default SvgPaymentRightArrow;